<template>
    <v-container fluid>
        <h2 class="text-h5 mb-4">{{ $t("risk-aversion.form4bis.title") }}</h2>
        <v-alert v-if="showUpdateSimulation" dense text border="left" type="info">
            <span style="color: black"> {{ $t("risk-aversion.form4bis.update-alert") }} </span>
        </v-alert>

        <v-alert border="left" prominent text type="warning" class="mt-4">
            <span style="color: black">
                {{ $t("risk-aversion.form4bis.date-warning") }}
            </span>
        </v-alert>
        <p class="font-weight-bold">
            {{ $t("risk-aversion.form4bis.validation-instruction") }}
        </p>

        <v-row align="center" align-content="center" justify="center">
            <v-col cols="12" sm="6">
                <EqsNumber
                    :value.sync="formData.p4bq1"
                    :is-currency="false"
                    :is-float="false"
                    v-bind="{
                        label: $t('risk-aversion.form4bis.q1-label'),
                        editable: true,
                        placeholder: 'Ex: 4500',
                        ...schemaDouble.p4bq1
                    }"
                >
                    <template #append-outer>
                        <v-tooltip open-on-hover right>
                            <template #activator="{ on, attrs }">
                                <span icon v-bind="attrs" v-on="on">
                                    <v-icon> mdi-information </v-icon>
                                </span>
                            </template>
                            <div class="tooltip-cst">
                                {{ $t("risk-aversion.form4bis.q1-tooltip") }}
                            </div>
                        </v-tooltip>
                    </template>
                </EqsNumber>
                <EqsNumber
                    :value.sync="formData.p4bq2"
                    :is-currency="false"
                    :is-float="false"
                    v-bind="{
                        label: $t('risk-aversion.form4bis.q2-label'),
                        editable: true,
                        placeholder: 'Ex: 15000',
                        ...schemaDouble.p4bq2
                    }"
                >
                    <template #append-outer>
                        <v-tooltip open-on-hover right>
                            <template #activator="{ on, attrs }">
                                <span icon v-bind="attrs" v-on="on">
                                    <v-icon> mdi-information </v-icon>
                                </span>
                            </template>
                            <div class="tooltip-cst">
                                {{ $t("risk-aversion.form4bis.q2-tooltip") }}
                            </div>
                        </v-tooltip>
                    </template>
                </EqsNumber>
                <EqsNumber
                    :value.sync="formData.p4bq3"
                    :is-currency="false"
                    :is-float="false"
                    v-bind="{
                        label: $t('risk-aversion.form4bis.q3-label'),
                        editable: true,
                        placeholder: 'Ex: 2000',
                        ...schemaDouble.p4bq3
                    }"
                >
                    <template #append-outer>
                        <v-tooltip open-on-hover right>
                            <template #activator="{ on, attrs }">
                                <span icon v-bind="attrs" v-on="on">
                                    <v-icon> mdi-information </v-icon>
                                </span>
                            </template>
                            <div class="tooltip-cst">
                                {{ $t("risk-aversion.form4bis.q3-tooltip") }}
                            </div>
                        </v-tooltip>
                    </template>
                </EqsNumber>
            </v-col>
            <v-col cols="12" sm="6" class="pl-10">
                <p>{{ $t("risk-aversion.form4bis.invest-capacity") }}</p>
                <p class="font-weight-bold">
                    {{ $currency.displayWithCurrency(investCapacity, "-") }} / deal
                </p>
            </v-col>
        </v-row>

        <EqsCheckbox
            :value.sync="formData.confirm_unwarned"
            :is-required="true"
            class="font-weight-bold mt-4 mb-4"
            v-bind="{
                editable: true,
                ...schemaDouble.confirm_unwarned
            }"
        >
            <template #label>
                {{ $t("risk-aversion.form4bis.confirm-unwarned") }}
            </template>
        </EqsCheckbox>
    </v-container>
</template>

<script>
import { formMixin } from "@equisafe-ui-vue/src/mixins/formMixin";

export default {
    name: "Form4bis",
    mixins: [formMixin],
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        isCompany: {
            type: Boolean,
            required: true
        },
        cipForm: {
            type: Object,
            required: true
        }
    },
    data() {
        return {};
    },
    computed: {
        investCapacity() {
            if (
                this.formData.p4bq1 !== null &&
                this.formData.p4bq2 !== null &&
                this.formData.p4bq3 !== null
            ) {
                const income = parseInt(this.formData.p4bq1);
                const shares = parseInt(this.formData.p4bq2);
                const debts = parseInt(this.formData.p4bq3);
                return Math.floor((income + shares - debts) * 0.1);
            }
            return null;
        },
        showUpdateSimulation() {
            return (
                this.cipForm.p4bq1 !== null &&
                this.cipForm.p4bq2 !== null &&
                this.cipForm.p4bq3 !== null
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.tooltip-cst {
    max-width: 300px;
    opacity: 1 !important;
}
</style>
